import axios from "axios";
import { REACT_APP_PROD_URL, PRICES_URL } from "../services/configs";

export const fetchHistoricData = (coin) => async (dispatch) => {
  const response = await axios.get(
    `${REACT_APP_PROD_URL}/v1/historic/${coin}INR`
  );

  dispatch({
    type: "FETCH_HISORIC_DATA",
    payload: response.data,
  });
};
